import React, { useState } from "react";

// Importa o arquivo de estilos
import "./Layout.css";

// Importa componetes do Bootstrap

// Importa os componentes
import HeaderBar from "./Components/HeaderBar/HeaderBar";
import MenuSidebar from "./Components/MenuSidebar/MenuSidebar";
import { useConfig } from "../../Provider/Config/config";

export default function Layout({ children }) {
    // Hooks for alert
    const { setConfig } = useConfig();

    // Hooks for translation

    // Menu collapsed
    const [collapsedMenu, setCollapsedMenu] = useState(false);
    const handleCollapsedChange = () => {
        setConfig("menuCollapsed", !collapsedMenu);
        setCollapsedMenu(!collapsedMenu);
    };

    // Menu show on mobile
    const [showMenu, setShowMenu] = useState(false);
    const handleShowMenu = () => {
        setShowMenu(!showMenu);
    };

    return (
        <div id="layout">
            <div id="menu-sidebar">
                <MenuSidebar
                    collapsed={collapsedMenu}
                    onShowMenu={handleShowMenu}
                    showOffcanvas={showMenu}
                    setShowOffcanvas={setShowMenu}
                />
            </div>
            <div id="content">
                <HeaderBar
                    collapsed={collapsedMenu}
                    onCollapsedMenu={handleCollapsedChange}
                    onShowMenu={handleShowMenu}
                />
                <div id="content-body">{children}</div>
            </div>
        </div>
    );
}
